import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {poolVariant} from '@/common/types/commonTypes.ts'
import {loadAllData, /*loadData*/} from "@/redux/poolThunks.ts";
import {IdlAccounts} from "@coral-xyz/anchor";
import {Revshare} from "@/components/SolanaPools/anchor-idl/idl.ts";




export type UserOnPool = IdlAccounts<Revshare>['userStateV2'] & {
  poolId: PoolId
}

export type PoolState = IdlAccounts<Revshare>['zenexPoolStateV2']


export type PoolIdKey = string // например: '2025-07'

export type TransactionStatus = {
  isOpen: boolean
  isSuccess: boolean
  token?: string
  signature?: string
  key?: string
}

export type PoolSliceState = {
  userData: Record<PoolIdKey, UserOnPool>
  poolData: Record<PoolIdKey, PoolState>
  isEnterToPoolDialogOpened: boolean
  buttonClicked: poolVariant
  transactionStatus: TransactionStatus
}

export type PoolId = {
  year: number
  month: number
}


const initialState = {
  userData: {} as Record<PoolIdKey, UserOnPool>,
  poolData: {} as Record<PoolIdKey, PoolState>,
  sortedUserPoolIds: [] as PoolId[],
  sortedPoolIds: [] as PoolId[],
  curUserData: undefined as UserOnPool | undefined,
  curPoolData: { } as PoolState,

  isEnterToPoolDialogOpened: false,
  buttonClicked: 'stable',
  transactionStatus: {
    isOpen: false,
    isSuccess: false,
    token: undefined,
    signature: undefined,
    key: undefined
  } as TransactionStatus
}


const poolSlice = createSlice({
  name: 'pool',
  initialState,
  reducers: {
    setEnterDialogOpened(state, action: PayloadAction<boolean>) {
      state.isEnterToPoolDialogOpened = action.payload
    },
    setButtonClicked(state, action: PayloadAction<poolVariant>) {
      state.buttonClicked = action.payload
    },
    setTransactionStatus(state, action: PayloadAction<TransactionStatus>) {
      state.transactionStatus = action.payload
    },
    closeTransactionStatus(state) {
      state.transactionStatus.isOpen = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAllData.pending, () => {
        console.info('loadAllData.pending')
      })
      .addCase(loadAllData.fulfilled, (state, action) => {

        const userData = {} as Record<PoolIdKey, UserOnPool>;
        const poolData = {} as Record<PoolIdKey, PoolState>;
        const userPoolIds: PoolId[] = [];

        (action.payload.userData ?? []).forEach((el) => {
          const id = "" + el.account.year + "-" + el.account.month
          userPoolIds.push(
            {
              month: el.account.month,
              year: el.account.year,
            }
          )

          userData[id] =
            {
              poolId: {
                month: el.account.month,
                year: el.account.year,
              },
              ...el.account
            };

        })

        const poolIds: PoolId[] = []

        for (const a in action.payload.poolData) {
          const id = "" + action.payload.poolData[a].account.year + "-" + action.payload.poolData[a].account.month
          poolIds.push(
            {
              month: action.payload.poolData[a].account.month,
              year: action.payload.poolData[a].account.year,
            }
          )
          poolData[id] = action.payload.poolData[a].account
        }

        const sortedPoolIds = poolIds.sort((a, b) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })

        const sortedUserPoolIds = userPoolIds.sort((a, b) => {
          if (a.year !== b.year) {
            return b.year - a.year
          }
          return b.month - a.month
        })

        state.userData = userData
        state.poolData = poolData
        state.sortedUserPoolIds = sortedUserPoolIds
        state.sortedPoolIds = sortedPoolIds

        //console.log('loadAllData.fulfilled pool and user data',state.poolData, state.userData)
        //console.log('loadAllData.fulfilled pool and user action', action.payload.userData)
        //console.log('loadAllData.fulfilled pool and user sorted',state.sortedUserPoolIds, state.sortedPoolIds)
      }).addCase(loadAllData.rejected, () => {
      console.warn('loadAllData.rejected')
    })
  }
})

export const {
  setEnterDialogOpened,
  setButtonClicked,
  setTransactionStatus,
  closeTransactionStatus,
} = poolSlice.actions


export const poolReducer = poolSlice.reducer